import { ErrorDialog } from '@/components/shared/error-dialog';
import { useErrorDialogStore } from '@/stores/error-dialog-store';

export function GlobalErrorDialog() {
	const { error, isOpen, clearError } = useErrorDialogStore();

	if (!error) return null;

	return <ErrorDialog error={error} open={isOpen} onClose={clearError} />;
}
